import React from 'react'
import moment from 'moment'
import { Date, Img, Item, Text } from '../style/NewsStyle'
import { Col } from 'antd'
import { Link } from 'react-router-dom'

interface Props {
  id: number
  title: string
  image: string
  preview: string
  date_creation: string
  lg: number
  md: number
  start: number
  big: boolean | undefined
}

const ItemNews = ({ data, lg = 12, md = 12, start = 0, big, formatData }: any) => {
  return data?.map(({ id, title, image, preview, date_creation }: Props, index: number) => {
    if (big) {
      if (index === 0)
        return (
          <Link to={`/news/${id}`} key={id}>
            <Item className="home-box-news">
              <Img big style={{ backgroundImage: `url(${image})` }} />
              <Text>
                <h4 className='home-box-news-title'>{title}</h4>
                <div dangerouslySetInnerHTML={{ __html: preview }} />
                <Date>
                  <span>{moment(date_creation).format(formatData)}</span>
                </Date>
              </Text>
            </Item>
          </Link>
        )
    } else if (index >= start) {
      return (
        <Col xxl={lg} md={md} key={id}>
          <Link to={`/news/${id}`}>
            <Item className="home-box-news">
              <Img style={{ backgroundImage: `url(${image})` }} />
              <Text>
                <h4 className='home-box-news-title'>{title}</h4>
                <div className="home-box-news-text" dangerouslySetInnerHTML={{ __html: preview }} />
                <Date className="home-box-news-date">
                  <span>{moment(date_creation).format(formatData)}</span>
                </Date>
              </Text>
            </Item>
          </Link>
        </Col>
      )
    }
  })
}

export default ItemNews
